import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=64a40d94"
import script from "./ExpandableText.vue?vue&type=script&lang=js"
export * from "./ExpandableText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports